import React, { useState } from 'react';
import { Line, Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend } from 'chart.js';
import MonthInput from "./MonthInput";

// Registramos los componentes necesarios de Chart.js
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,  // Aquí se agrega el registro de PointElement
    Title,
    Tooltip,
    Legend
);

const GraficosReportes = () => {
    // Simulación de datos para los gráficos (6 meses de ejemplo)
    const [dataIngresos, setDataIngresos] = useState({
        labels: ['Ene - 25', 'Feb - 25', 'Mar - 25', 'Abr - 25', 'May - 25', 'Jun - 25'],
        datasets: [
            {
                label: 'Ingresos',
                data: [500000, 610000, 715000, 780000, 850000, 920000], // Ingresos por mes con variación
                fill: false,
                borderColor: 'green',
                tension: 0.3
            }
        ]
    });

    const [dataEvolucionAuxiliar, setdataEvolucionAuxiliar] = useState({
        labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        datasets: [
            {
                label: '2024',
                data: [97, 102, 106, 109, 114, 117, 119, 122, 118, 118, 118, 120],
                fill: false,
                borderColor: 'orange',
                tension: 0.3
            },
            {
                label: '2025',
                data: [99, 104],
                fill: false,
                borderColor: 'green',
                tension: 0.3
            }
        ]
    });
    
    const [dataEvolucionTurnos, setdataEvolucionTurnos] = useState({
        labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        datasets: [
            {
                label: '2024',
                data: [87, 92, 96, 99, 103, 106, 109, 111, 108, 118, 118, 120],
                fill: false,
                borderColor: 'orange',
                tension: 0.3
            },
            {
                label: '2025',
                data: [89, 94],
                fill: false,
                borderColor: 'green',
                tension: 0.3
            }
        ]
    });
    
    const [dataEvolucionPacientes, setdataEvolucionPacientes] = useState({
        labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        datasets: [
            {
                label: '2024',
                data: [77, 82, 86, 89, 93, 96, 99, 101, 98, 118, 118, 120],
                fill: false,
                borderColor: 'orange',
                tension: 0.3
            },
            {
                label: '2025',
                data: [79, 84],
                fill: false,
                borderColor: 'green',
                tension: 0.3
            }
        ]
    });
    
    const [dataFacturacion, setdataFacturacion] = useState({
        labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        datasets: [
            {
                label: 'Facturación 2024',
                data: [2000000, 5000000, 12000000, 15000000, 30000000, 45000000, 55000000, 60000000, 75000000, 85000000, 90000000, 100000000],
                fill: false,
                borderColor: 'blue',
                tension: 0.3
            },
            {
                label: 'Facturación 2025',
                data: [2200000, 4800000],
                fill: false,
                borderColor: 'red',
                tension: 0.3
            }
        ]
    });
    
    const [dataEvolucionMargen, setdataEvolucionMargen] = useState({
        labels: ['01 Ene', '02 Ene', '03 Ene', '04 Ene', '05 Ene', '06 Ene', '07 Ene', '08 Ene', '09 Ene', '10 Ene'],
        datasets: [
            {
                label: 'Margen 2024',
                data: [500000, 800000, 600000, 750000, 900000, 850000, 700000, 950000, 880000, 920000],
                fill: false,
                borderColor: 'green',
                tension: 0.3
            },
        ]
    });

    const [dataEgresos, setDataEgresos] = useState({
        labels: ['Ene - 25', 'Feb - 25', 'Mar - 25', 'Abr - 25', 'May - 25', 'Jun - 25'],
        datasets: [
            {
                label: 'Egresos',
                data: [200000, 255000, 290000, 340000, 380000, 430000], // Egresos por mes con variación
                fill: false,
                borderColor: 'red',
                tension: 0.3
            }
        ]
    });

    const [dataPagosPacientes, setDataPagosPacientes] = useState({
        labels: ['Ene - 25', 'Feb - 25', 'Mar - 25', 'Abr - 25', 'May - 25', 'Jun - 25'],
        datasets: [
            {
                label: 'Pagos Pacientes',
                data: [100000, 150000, 120000, 170000, 190000, 210000], // Pagos a pacientes por mes
                fill: false,
                borderColor: 'blue',
                tension: 0.3
            }
        ]
    });

    const [dataRemuneraciones, setDataRemuneraciones] = useState({
        labels: ['Ene - 25', 'Feb - 25', 'Mar - 25', 'Abr - 25', 'May - 25', 'Jun - 25'],
        datasets: [
            {
                label: 'Remuneraciones',
                data: [150000, 180000, 200000, 220000, 240000, 260000], // Remuneraciones por mes
                fill: false,
                borderColor: 'purple',
                tension: 0.3
            }
        ]
    });

    const [dataTotales, setDataTotales] = useState({
        labels: ['Ene - 25', 'Feb - 25', 'Mar - 25', 'Abr - 25', 'May - 25', 'Jun - 25'],
        datasets: [
            {
                label: 'Totales (Ingresos - Egresos)',
                data: [300000, 355000, 425000, 440000, 470000, 490000], // Totales calculados por mes
                fill: true,
                backgroundColor: 'rgba(0, 123, 255, 0.2)',
                borderColor: 'rgba(0, 123, 255, 1)',
                tension: 0.3
            }
        ]
    });

    return (
        <div className="container mt-5">
            <h3 className="text-center mb-4">Estado Financiero - Gráficos por Mes</h3>

            {/* Filtro de Periodo */}
            <div className="card mb-4">
                <div className="card-body">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-4 mb-2 mb-md-0">
                            <MonthInput
                                className="form-control"
                                id="periodo_inicio"
                                name="periodo_inicio"
                                defaultValue="2025-01"
                            />
                        </div>
                        <div className="col-12 col-md-4 mb-2 mb-md-0">
                            <MonthInput
                                className="form-control"
                                id="periodo_fin"
                                name="periodo_fin"
                                defaultValue="2025-01"
                            />
                        </div>
                        <div className="col-12 col-md-4 text-md-end">
                            <button className="btn btn-primary">Buscar</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Gráficos */}
            <div className="row">
                <div className="col-md-6 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <h5>Ingresos</h5>
                            <Line data={dataIngresos} options={{ responsive: true }} />
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <h5>Egresos</h5>
                            <Line data={dataEgresos} options={{ responsive: true }} />
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <h5>Pagos a Pacientes</h5>
                            <Line data={dataPagosPacientes} options={{ responsive: true }} />
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <h5>Remuneraciones</h5>
                            <Line data={dataRemuneraciones} options={{ responsive: true }} />
                        </div>
                    </div>
                </div>

                <div className="col-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <h5>Totales (Ingresos - Egresos)</h5>
                            <Bar data={dataTotales} options={{ responsive: true }} />
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <h5>Evolución n° aux</h5>
                            <Line data={dataEvolucionAuxiliar} options={{ responsive: true }} />
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <h5>Evolución n° turnos</h5>
                            <Line data={dataEvolucionTurnos} options={{ responsive: true }} />
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <h5>Evolución n° pacientes</h5>
                            <Line data={dataEvolucionPacientes} options={{ responsive: true }} />
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <h5>Facturacion</h5>
                            <Line data={dataFacturacion} options={{ responsive: true }} />
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <h5>Evolucion margen</h5>
                            <Line data={dataEvolucionMargen} options={{ responsive: true }} />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default GraficosReportes;
